export class TimeZoneHelper {
  public static getLocalTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Paris';
  }
}
